export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7331.385ffeb7.jpg";